import axios from "axios";
import TimelineSeries from "@/features/Timeline/TimelineSeries";

export class TimelineService {
    private timelineURL = "/api/v1/timeline";

    async getTimelineSeries(query: object): Promise<TimelineSeries[]> {
        const queryParams = {
            params: query,
            paramsSerializer: function (params: any) {
                const searchParams = new URLSearchParams();
                for (const key of Object.keys(params)) {
                    const param = params[key];
                    if (Array.isArray(param)) {
                        for (const p of param) {
                            searchParams.append(key, p);
                        }
                    } else {
                        searchParams.append(key, param);
                    }
                }
                return searchParams.toString();
            },
        };

        const response = await axios.get(this.timelineURL, queryParams);

        return response.data;
    }
}
